import { EventInfo } from '../types';

export const eventInfo: EventInfo = {
  name: 'Iron Makers Day @ one:demo forge',
  date: 'February 17, 2026',
  location: 'one:demo forge - intercity hotel dresden main station',
  description: 'Networking. Learning. Demo-Creation.',
  rules: [
    'Be in time',
    'Follow the moderator',
    'Have fun and be creative',
    'No discussions between teams during "doing"',
    'Be better together'
  ]
};
